import graphicsUrl from "@/assets/select-your-repository-showcase-graphics.svg";

export const SelectRepositoryShowcase = () => {
    return (
        <div className="flex h-full w-full flex-col items-center justify-center p-4">
            <img
                src={graphicsUrl}
                alt="Graphics for increasing autonomy through security"
                className="mb-6 max-h-[75%] w-auto select-none object-contain"
            />
            <p className="mb-2 text-center text-3xl font-medium text-white drop-shadow-sm">Sandboxed Ona environments</p>
            <p className="max-w-lg text-center text-lg text-white/90 drop-shadow-sm">
                Each Ona Agent executes within ephemeral Ona Environments with full OS-level isolation.
            </p>
        </div>
    );
};
